import React from "react";
import { Spinner } from "@simply007org/react-spinners";
const careBlueLogo = require("../assets/loader-white.png");

export default class GlobalLoader extends React.Component {
  render() {
    return (
      <div style={{display:"flex"}}>
        <Spinner name="mySpinner">
          <div className="overlay">
            <div className="loader-container">
              <img className="loader-image" src={careBlueLogo} />
              <div className="loading">Loading&#8230;</div>
            </div>
          </div>
        </Spinner>
      </div>
    );
  }
}
